import { DOCUMENT, Location } from "@angular/common";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import {
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService,
} from "@azure/msal-angular";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor extends MsalInterceptor implements HttpInterceptor {
  private msalService: MsalService;

  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG) msalInterceptorConfig: MsalInterceptorConfiguration,
    authService: MsalService,
    location: Location,
    msalBroadcastService: MsalBroadcastService,
    @Inject(DOCUMENT) document?: unknown,
  ) {
    super(msalInterceptorConfig, authService, location, msalBroadcastService, document);
    this.msalService = authService;
  }

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //if don't have signed in user don't add token for api call
    // because msal interceptor automatically tries to acquire token (first trie silently
    // and then interactively). We don't want to trigger authentication in case user is not authenticated
    // e.g. accessing Login  or requestAccount pages.
    if (this.msalService.instance.getAllAccounts().length > 0) {
      return super.intercept(req, next);
    }

    return next.handle(req);
  }
}
